<app-header-title>
  <span title>{{'addemployee.EmployeeResignation'|translate}}</span>
</app-header-title>

<div class="publicsetting" style="padding: 0rem 3rem;">
  <dx-data-grid #grid class="dx-card wide-card" [dataSource]="customDataSource" [showBorders]="false"
    [focusedRowEnabled]="true" [focusedRowIndex]="0" [allowColumnResizing]="true" [columnAutoWidth]="true"
    [columnHidingEnabled]="true" [showColumnLines]="false" [rowAlternationEnabled]="true" [showRowLines]="false"
    [showBorders]="false" (onRowUpdating)="updateRow($event)" (onInitNewRow)="onInitNewRow($event)"
    (onEditingStart)="onEditingStart()" [errorRowEnabled]="false" [rtlEnabled]="currentLang=='ar'?true:false"
    (onSaved)="Saved()">

    <dxo-editing mode="popup" [useIcons]="false" [allowAdding]="true" [allowDeleting]="true" [allowUpdating]="true"
      (changesChange)="changesChange($event)" [texts]="button">
      <dxo-popup [title]="addpopup" [showTitle]="true" [width]="1500" [height]="525" [hideOnOutsideClick]="true"
        [dragEnabled]="false">

      </dxo-popup>

      <dxo-form labelMode="floating" labelLocation="top">

  <dxi-item dataField="branchId"></dxi-item>

  <dxi-item dataField="employeeId"></dxi-item>

  <dxi-item dataField="status"></dxi-item>

  <dxi-item dataField="resignationReason"></dxi-item>

  <dxi-item dataField="date"></dxi-item>

</dxo-form>

      <dxo-texts [addRow]="addrowfun('basic-info.bank.name')"
        confirmDeleteMessage="{{'tableinfo.deletebutton'|translate}}">
      </dxo-texts>
    </dxo-editing>
<dxo-paging  [pageSize]="10"> </dxo-paging>    <dxo-pager [visible]="true" allowedPageSizes="true" displayMode="full" [showPageSizeSelector]="true"
      [showInfo]="false" [showNavigationButtons]="true">
    </dxo-pager>
    <dxo-filter-row [visible]="true"></dxo-filter-row>

    <dxi-column dataField="branchId" caption="{{'cdc.branch'|translate}}">
      <dxo-lookup [dataSource]="branchesDropDown" valueExpr="id"
        [displayExpr]="currentLang=='ar'?'nameAr':'nameAr'"></dxo-lookup>
    </dxi-column>

   <dxi-column
  dataField="employeeId"
  caption="{{'tableinfo.employee' | translate}}"
  [visible]="false">

  <dxo-lookup
    [dataSource]="employeeDropDown"
    valueExpr="id"
    [displayExpr]="currentLang == 'ar' ? 'nameAr' : 'nameEn'">
  </dxo-lookup>

</dxi-column>
<dxi-column
  dataField="employeeName"
  caption="{{'tableinfo.employee' | translate}}">
</dxi-column>
    <dxi-column dataField="status" caption="{{'salary.status'|translate}}" [allowEditing]="false">
      <dxo-lookup [dataSource]="employeeStatus" valueExpr="code" displayExpr="name"></dxo-lookup>
    </dxi-column>
    
    <dxi-column dataField="resignationReason" caption="{{'tableinfo.description'|translate}}"></dxi-column>
    <dxi-column dataField="date" dataType="date" [allowEditing]="true"
      caption="{{'tableinfo.dateOfRegistration'|translate}}"></dxi-column>

    <dxi-column type="buttons">
      <dxi-button name="edit" text="{{'tableinfo.editbutton' | translate}}" [visible]="shouldShowActionButtons">
      </dxi-button>
      <dxi-button name="delete" text="{{'tableinfo.removebutton' | translate}}" [visible]="shouldShowActionButtons">
      </dxi-button>
    </dxi-column>

    <dxo-remote-operations [groupPaging]="true">
    </dxo-remote-operations>
  </dx-data-grid>
</div>